import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, BASE_URL } from '../api/client';

export const thunkProvinsiName = 'api/master/provinsi';
export const sliceProvinsiName = 'provinsi';

export const getData = createAsyncThunk(thunkProvinsiName, async (_, { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkProvinsiName);
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const provinceSlice = createSlice({
  name: sliceProvinsiName,
  initialState: {
    data: [],
    status: 'idle',
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getData.pending, (state, action) => {
        state.data = [];
        state.status = 'loading';
        state.message = '';
        state.error = null;
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.status = 'succeeded';
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(getData.rejected, (state, action) => {
        state.data = [];
        state.status = 'failed';
        state.message = action.payload.message;
        state.error = action.payload.errors;
      });
  },
});

export default provinceSlice.reducer;
